import { request } from '@/request/request';
import { parameterChange } from '@/utils';

export default {
  // 证书列表
  certificateList(data) {
    return request({
      url: `${process.env.VUE_APP_BIN_PREFIX}/cohf/certificateTemplate/list?${parameterChange(data)}`,
      method: 'get',
      data,
    });
  },
  // 证书详情
  certificateDetail(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/certificate_info/certificateDetail?${parameterChange(data)}`,
      method: 'get',
    });
  },
  // 证书新增
  certificateAdd(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/certificate_info/certificateAdd`,
      method: 'post',
      data,
    });
  },
  // 证书编辑
  certificateUpdate(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/certificate_info/certificateUpdate`,
      method: 'post',
      data,
    });
  },
  // 证书删除
  certificateDelete(data) {
    return request({
      url: `${process.env.VUE_APP_OU_PREFIX}/certificate_info/certificateDelete`,
      method: 'post',
      data,
    });
  },
  // 证书详情
  certificateTemplate(data) {
    return request({
      url: `${process.env.VUE_APP_BIN_PREFIX}/cohf/certificateTemplate/list?${parameterChange(data)}`,
      method: 'get',
    });
  },
};
